import { axiosInstance } from '../App';
import { QueueNumberDTO } from '../interface/interface';

export function getActiveQueueNumbers(): Promise<QueueNumberDTO[]> {
  return axiosInstance.get('/api/secured/patientcallercontroller/getActiveQueueNumbers')
    .then(res => res.data);
}

export function getQueueNumbersSortedByPA(hardwareId: string): Promise<QueueNumberDTO[]> {
  return axiosInstance.get('/api/secured/patientcallercontroller/getQueueNumbersSortedByPA', {
    params: {
      hardwareId: hardwareId
    }
  })
    .then(res => res.data);
}

export function getHistoricQueueNumbers(): Promise<QueueNumberDTO[]> {
  return axiosInstance.get('/api/secured/patientcallercontroller/getHistoricQueueNumbersOfDay')
    .then(res => res.data);
}

export function createQueueNumber(queueStringId: string, associatedPatientId?: number): Promise<QueueNumberDTO> {
  return axiosInstance.post('/api/secured/queue/CreateQueueNumbers', null, {
    params: {
      queueStringId,
      associatedPatientId
    }
  }).then(res => res.data);
}

export function callPatient(dto: QueueNumberDTO, hardwareId: string) {
  return axiosInstance.post(`/api/secured/patientcallercontroller/callPatient`, dto, {
      params: {
        hardwareId: hardwareId
      }
    }
  ).then(res => res.data);
}

export function deactivateQueueNumber(queueNumberId: number): Promise<void> {
  return axiosInstance.post(`/api/secured/patientcallercontroller/deactivatequeuenumber`, null, {
      params: {
        queueNumberId: queueNumberId
      }
    }
  ).then(() => {});
}

// TODO: Implementar lógica de asignación de prioridad en el backend

// export function setPriority(queueNumberId: number, priority: number): Promise<void> {
//   return axiosInstance.post(`/api/secured/queue/setQueueNumberPriority/${queueNumberId}`, null, {
//     params: { priority }
//   }).then(() => {});
// }